import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ExamsRolloverService {

  constructor(
    private http: HttpClient,
    private jsonObjectFactory: JsonObjectFactoryService,
  ) {}

  getTaxYearDropDown(baseUrl: string, globalService: any): Observable<any> {
    const url = baseUrl + '/loadJsonObject';
    const params: any = { action_code: 'e83e1x' };

    if (globalService?.globalParams) {
      const gp = globalService.globalParams;
      if (gp.sso_id) params.sso_id = gp.sso_id;
      if (gp.jcd_key) params.jcd_key = gp.jcd_key;
      if (gp.scenario) params.scenario = gp.scenario;
      if (gp.screen_key) params.screen_key = gp.screen_key;
      if (gp.tax_year) params.tax_year = gp.tax_year;
    }

    return this.jsonObjectFactory.getJSONObj(url, params, globalService);
  }

  getScenarioDropDown(baseUrl: string, taxYear: string, globalService: any): Observable<any> {
    const url = baseUrl + '/loadJsonObject';
    const params: any = {
      action_code: '7q0wiy',
      tax_year: taxYear,
    };

    if (globalService?.globalParams) {
      const gp = globalService.globalParams;
      if (gp.sso_id) params.sso_id = gp.sso_id;
      if (gp.jcd_key) params.jcd_key = gp.jcd_key;
      if (gp.screen_key) params.screen_key = gp.screen_key;
    }

    return this.jsonObjectFactory.getJSONObj(url, params, globalService);
  }

  /**
   * Original AngularJS used $http.post() directly (JSON body), NOT JsonObjectFactory.saveJSON.
   * Action code: uveuip
   * Merge order: GlobalService.globalParams first, then rolloverObj overrides.
   */
  executeExamsRollover(
    baseUrl: string,
    ssoId: string,
    taxYear: string,
    sourceScenario: string,
    targetScenario: string,
    jcdKey: string,
    globalService: any,
  ): Observable<any> {
    const url = baseUrl + '/saveJsonObject?action_code=uveuip';

    const params: any = {};
    if (globalService?.globalParams) {
      Object.assign(params, globalService.globalParams);
    }

    params.sso_id = ssoId || params.sso_id;
    params.p_tax_year = taxYear;
    params.p_source_scenario = sourceScenario;
    params.p_target_scenario = targetScenario;
    params.jcd_key = jcdKey || params.jcd_key;

    return this.http.post<any>(url, params, { withCredentials: true });
  }
}
